import {ADD_ME, REMOVE_ME} from '../constants/';

const INIT_STATE = JSON.parse(localStorage.getItem('me'));

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case ADD_ME:
      return {
        ...state,
        ...action.payload,
      };
    case REMOVE_ME:
      return {};
    default:
      return state;
  }
};
